/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MainHeaderComponent } from './main-header/main-header.component';
import { Title } from '@angular/platform-browser';
import { HeaderMenuComponent } from './header-menu/header-menu.component';
import { MaterialModule } from 'src/app/common/material/material-module';
import { SideNavComponent } from './side-nav/side-nav.component';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { LoginHeaderComponent } from './login-header/login-header.component';
import { SupportDialogComponent } from './support-dialog/support-dialog.component';
import { CheckboxListModule } from 'src/app/shared/ui/material/checkbox-list/checkbox-list.module';
import { DialogReusableModule } from 'src/app/common/dialog-reusable/dialog-reusable.module';

@NgModule({
	declarations: [
		MainHeaderComponent,
		HeaderMenuComponent,
		SideNavComponent,
		LoginHeaderComponent,
		SupportDialogComponent,
	],
	imports: [
		CommonModule,
		DialogReusableModule,
		MaterialModule,
		CheckboxListModule,
		ReactiveFormsModule,
		RouterModule,
	],
	exports: [MainHeaderComponent, HeaderMenuComponent, SideNavComponent, LoginHeaderComponent, MaterialModule],
	providers: [Title],
})
export class CommonComponentsModule {}
